var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('section',[_c('div',{staticClass:"hero-body"},[_c('div',{staticClass:"container"},[_c('h1',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.$t('notfound_title'))+" ")]),_c('h2',{staticClass:"subtitle"},[_c('br'),_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t('notfound_text'))}})])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }